import React, { useContext } from 'react';
import { navigate } from '@reach/router';

import AuthContext from '../../../services/firebase/AuthContext';
import { createFirm } from '../../solicitors/FirmData';
import LoggingContext from '../../../services/logging/LoggingContext';
import FindFirmForm from '../../solicitors/FindFirmForm';
import FireDataContext from '../../../services/firebase/FireDataContext';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import Grid from '@material-ui/core/Grid';
import Spacer from '../../../app/common/ui/Spacer';
import Typography from '@material-ui/core/Typography'

const CreateOrganizationPage = () => {
    const db = useContext(FireDataContext);
    const Errata = useContext(LoggingContext);
    const { currentUser } = useContext(AuthContext);
    const { uid = 'WTAF' } = currentUser || {};

    const handleFirmSelect = ({ office, firm }) => {
        (async () => {
            try {
                const organization = await createFirm({ db, firm, office, uid });
                navigate(`/admin/organization/${organization.id}`);
            }
            catch (error) {
                Errata.log({component: 'CreateOrganizationPage', user: currentUser, error});
            
            }
        })();
    }

    return (
        <MemberMiniMenu>
            <Typography variant="h6" color="initial">Search Solicitors</Typography>
            <Spacer />
            <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                    <FindFirmForm onSelect={handleFirmSelect} />
                </Grid>
            </Grid>
        </MemberMiniMenu>
    );
};

export default CreateOrganizationPage;